module.exports = __webpack_public_path__ + "static/email-gif-b12ed39018ed10c1ef2e7dcbf60b4c6b.gif";